import styled from 'styled-components';

export default styled.div`
	display: flex;
	align-items: center;
	gap: var(--spacing-x-small);

	.cd-label {
		color: var(--neutrals-700);
	}

	.cd-blue {
		color: var(--blue-600);
	}

	.cd-orange {
		color: var(--orange-600);
	}

	.cd-purple {
		color: var(--purple-600);
	}

	.cd-maroon {
		color: var(--maroon-600);
	}

	.cd-teal {
		color: var(--teal-600);
	}
`;
